import React from 'react';
import Skeleton from '.';


const getByTabId = (tabId) => {
    switch (tabId) {
        case 'tab_application_form':
            return <Skeleton.ApplicationFormBuilderSkeleton />;
        case 'tab_flow_automations':
            return <Skeleton.RecruitmentFlowSkeleton />;
        case 'tab_evaluations':
            return <Skeleton.EvaluationSkeleton />;
        case 'tab_edit_job_posting':
            return <Skeleton.StyleThemeSkeleton />;
        case 'tab_position_details':
        default:
            return <>
                <Skeleton type="detail-form" />
                <Skeleton type="salary_info" />
                <Skeleton type="ckeditor" title={false} />
            </>;
    }
};
const PageSkeleton = ({ tabId }) => {
    return (
        <div className="page-skeleton-wrapper page-width-wrapper">
            <Skeleton type="header" />
            <Skeleton type="tabs" />
            {getByTabId(tabId)}
        </div>
    );
};

export default PageSkeleton;
